import { fcaFastApi, fcaGateWay, fcaReportGateway } from "../../services/authorizationService";
import * as serviceEndpoints from "../../config/serviceEndPoints";
import { isEnabled } from "../../services/featureFlags";

// export const getListForCommonFilter = (params, id) =>
//     fcaGateWay.get(`${serviceEndpoints.projectEndPoints.getListForCommonFilter}/${id}/trades/get_list`, {
//         params
//     });
export const getChartTemplates = params =>
    isEnabled("migrate_chart_template")
        ? fcaFastApi.get(serviceEndpoints.chartTemplateEndPoints.chartTemplatesFastApi, { params })
        : fcaReportGateway.get(`${serviceEndpoints.chartTemplateEndPoints.chartTemplates}`, { params });

export const addChartTemplate = params =>
    isEnabled("migrate_chart_template")
        ? fcaFastApi.post(serviceEndpoints.chartTemplateEndPoints.chartTemplatesFastApi, params)
        : fcaReportGateway.post(serviceEndpoints.chartTemplateEndPoints.chartTemplates, params);

export const getChartTemplateById = id =>
    isEnabled("migrate_chart_template")
        ? fcaFastApi.get(`${serviceEndpoints.chartTemplateEndPoints.chartTemplatesFastApi}${id}`)
        : fcaReportGateway.get(`${serviceEndpoints.chartTemplateEndPoints.chartTemplates}${id}`);

export const updateChartTemplate = (params, id) =>
    isEnabled("migrate_chart_template")
        ? fcaFastApi.patch(`${serviceEndpoints.chartTemplateEndPoints.chartTemplatesFastApi}${id}/`, params)
        : fcaReportGateway.patch(`${serviceEndpoints.chartTemplateEndPoints.chartTemplates}${id}/`, params);

export const deleteChartTemplate = params =>
    isEnabled("migrate_chart_template")
        ? fcaFastApi.delete(`${serviceEndpoints.chartTemplateEndPoints.chartTemplatesFastApi}soft_delete/`, { params })
        : fcaReportGateway.delete(`${serviceEndpoints.chartTemplateEndPoints.chartTemplates}soft_delete/`, { params });

// export const restoreTemplate = id => fcaReportGateway.post(`${serviceEndpoints.reportTemplateEndPoints.template}revoke/${id}/`);

export const exportChartTemplate = params =>
    fcaReportGateway.get(`${serviceEndpoints.chartTemplateEndPoints.exportExcel}`, { responseType: "blob", method: "GET", params });

export const getChartPropertyDropdown = params =>
    fcaReportGateway.get(`${serviceEndpoints.chartTemplateEndPoints.getChartPropertyDropdown}`, { params });

// export const addUserActivityLog = text => fcaGateWay.post(`${serviceEndpoints.logEndPoints.addLog}`, text);
export const updateTemplateStatus = params =>
    isEnabled("migrate_chart_template")
        ? fcaFastApi.post(`${serviceEndpoints.chartTemplateEndPoints.chartTemplatesFastApi}set_status/`, params)
        : fcaReportGateway.post(`${serviceEndpoints.chartTemplateEndPoints.chartTemplates}set_status/`, params);
export const updateTemplateSmartChartStatus = params =>
    isEnabled("migrate_chart_template")
        ? fcaFastApi.post(`${serviceEndpoints.chartTemplateEndPoints.chartTemplatesFastApi}set-sm-status/`, params)
        : fcaReportGateway.post(`${serviceEndpoints.chartTemplateEndPoints.chartTemplates}set-sm-status/`, params);
export const updateTocStatus = params =>
    isEnabled("migrate_chart_template")
        ? fcaFastApi.post(`${serviceEndpoints.chartTemplateEndPoints.chartTemplatesFastApi}set-toc-status/`, params)
        : fcaReportGateway.post(`${serviceEndpoints.chartTemplateEndPoints.chartTemplates}set-toc-status/`, params);
export const updateTemplateOnePagerStatus = params =>
    isEnabled("migrate_chart_template")
        ? fcaFastApi.post(`${serviceEndpoints.chartTemplateEndPoints.chartTemplatesFastApi}set-one_pager-status/`, params)
        : fcaReportGateway.post(`${serviceEndpoints.chartTemplateEndPoints.chartTemplates}set-one_pager-status/ `, params);
